<template>
  <hs-dialog v-model="showSortDialog" style="z-index:300">
    <div class="sortDialog" :style="{height: iframeHeight}">
      <hs-date-header logoName="close_5.png" :title="title" @close="close"/>
      <div class="details">
        <iframe width="100%" height="100%" :src="url"></iframe>
      </div>
    </div>
  </hs-dialog>
</template>
<script type="text/ecmascript-6">
import HsScroll from 'base/hs-scroll/hs-scroll'
import {cloneObject} from '../../common/utility/utils';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    iframeHeight: {
      type: String,
      default: '90%'
    }
  },
  computed: {},
  created() {
    this.sort = this.selectedIndex
  },
  watch: {
    showSortDialog(val) {
      if (val) {
        setTimeout(() => {
          this.currentData = cloneObject(this.data)
        }, 200)
      }
    }
  },
  data() {
    return {
      showSortDialog: false
    }
  },
  methods: {
    show() {
      this.showSortDialog = true
    },
    close() {
      this.showSortDialog = false
    },
    // 获取当前组件是否已经打开
    getIsOpen() {
      if (this.showSortDialog) {
        this.close()
        return true
      }
      return false
    }
  },
  components: {
    HsScroll,
    HsCell1: () => import('base/hs-tableview/hs-cell-1/hs-cell-1'),
    HsDateHeader: () => import('base/hs-date-picker/hs-date-header'),
    HsDialog: () => import('base/hs-dialog/hs-dialog')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.sortDialog
  @extend .flex-column
  @extend .flex-end
  position absolute
  width 100%
  left 0
  bottom 0
  background-color $color_white
  border-radius 10px 10px 0 0
  max-height 90%
  .hs-picker-title
    border-bottom 1px solid $color_gray_layer
  >>> .hs-cell-1 >.details >.logo
    width 15px
    height 15px
  .details
    width 100%
    height calc(100% - 45px)
</style>
